import React, { Component } from 'react';
import PropTypes from 'prop-types';
import accessorialList from 'config/accessorials';
import OfferAccessorial from 'components/offers/offer-accessorial';
class Accessorials extends Component {
    hasAccessorials() {
        const { accessorials, } = this.props;
        if (accessorials && accessorials.length > 0) {
            return true;
        }
        return false;
    }
    mapAccessorials(accessorials) {
        return accessorials.map(accessorial => (Object.assign({}, accessorialList[accessorial.key])));
    }
    render() {
        if (!this.hasAccessorials()) {
            return (React.createElement("p", null, "There are no accessorials. To add, please manage shipment accessorials."));
        }
        const { accessorials, } = this.props;
        const mappedAcessorialImages = this.mapAccessorials(accessorials).map((accessorial, i) => (React.createElement(OfferAccessorial, { accessorial: accessorial, key: i })));
        return (React.createElement("div", { className: "accessorials-wrapper", style: { marginTop: '1rem' } },
            React.createElement("div", { className: "offer-accessorials" }, mappedAcessorialImages)));
    }
}
Accessorials.propTypes = {
    accessorials: PropTypes.array,
};
export default Accessorials;
